/**
 * 加盟店側-各種操作ボタン一覧
 * メモ：申請詳細の各種操作のボタンの一覧
 */
import React, { useState } from "react";

import clsx from "clsx";
import { Grid, Button, makeStyles } from "@material-ui/core";
import MessageIcon from "@material-ui/icons/Message";

import { buttonStyles } from "../../../../common/components/styles";

import { FONT, GUEST_COLOR } from "../../../../../constants/common";

import DealUserMessageModal from "./DealUserMessageModal";

const useStyles = makeStyles(() => ({
  commonButton: {
    paddingTop: 11,
    paddingBottom: 11,
    textAlign: "center",
  },
  commonIcon: {
    position: "absolute",
    top: 11,
    left: 20,
  },
  message: {
    fontSize: "0.9em",
    fontWeight: "bold",
    fontFamily: FONT,
    color: GUEST_COLOR.primary,
    marginBottom: 15,
  },
  buttonGridList: {
    margin: "0 auto",
  },
  buttonGrid: {
    width: "49%",
  },
}));

type Props = {
  dealId: number;
};

const DealShowButtonList: React.FC<Props> = (props: Props) => {
  const classes = useStyles();
  const buttonClasses = buttonStyles({
    width: "100%",
    marginTop: 0,
    backgroundColor: GUEST_COLOR.primary,
  });

  const { dealId } = props;

  const [userMessageOpen, setUserMessageOpen] = useState(false);

  return (
    <>
      {userMessageOpen && (
        <DealUserMessageModal dealId={dealId} setOpen={setUserMessageOpen} />
      )}
      <Grid container spacing={2} className={classes.buttonGridList}>
        <Grid item xs={12}>
          <Grid container justify="flex-start" spacing={2}>
            {/* メッセージ送信 */}
            <Grid item className={classes.buttonGrid}>
              <Button
                onClick={() => {
                  setUserMessageOpen(true);
                }}
                className={clsx(buttonClasses.button, classes.commonButton)}
                variant="contained"
              >
                <MessageIcon className={classes.commonIcon} />
                メッセージを送信する
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default DealShowButtonList;
